import { Contest } from '@Models';
import {
  buildEntityActionState,
  EntityActionState,
} from '../EntityActionState';

export type MyContestState = EntityActionState<Contest>;

export const buildMyContestState = (data: Partial<MyContestState> = {}) =>
  buildEntityActionState<Contest>(data);

export enum MyContestStateAction {
  REQUEST_ADD_TEAM = 0,
  REQUEST_ADD_PARTICIPANT = 1,
  REQUEST_DELETE = 2,
}
